<template>
	<!-- Create evaluation question -->
	<div class="container-evaluation-question">
		<ja-dropdown
			v-model="questionTypeIndex"
			:label="$t('questionType')"
			:options="questionTypeOptions"
			name="simulationType"
		></ja-dropdown>
		<ja-dropdown
			v-if="
				evaluationQuestions.cmsLifestyleQuestionType
					.lifestyle_Question_Type_ID !== 4
			"
			v-model="lifeStageIndex"
			:label="$t('lifeStage')"
			:options="lifeStageOptions"
			name="simulationType"
		></ja-dropdown>
		<div
			v-if="
				evaluationQuestions.cmsLifestyleQuestionType
					.lifestyle_Question_Type_ID === 4
			"
			class="container-buttons"
		>
			<input
				id="isAtEndOfSimulation"
				v-model="evaluationQuestions.isAtEndOfSimulation"
				type="checkbox"
				class="checkbox"
			/>
			<label for="isAtEndOfSimulation" class="heading-5">{{
				$t('onlyAtEndOfSimulation')
			}}</label>
		</div>
		<ja-dropdown
			v-model="questionFormatIndex"
			:label="$t('questionFormat')"
			:options="questionFormatOptions"
			name="questionFormat"
		></ja-dropdown>
		<div
			v-if="
				evaluationQuestions.lifestyle_Question_Type_ID ===
					lifestyleQuestionTypes.PREPOST
			"
			class="container-buttons"
		>
			<ja-input
				v-model="evaluationQuestions.questionOrder"
				:max-length="2"
				is-number-input
				:label="$t('questionOrder')"
				:name="$t('questionOrder')"
			></ja-input>
		</div>
		<div
			v-if="
				evaluationQuestions.cmsLifeStyleQuestionFormat
					.lifestyle_Question_Format_ID !== 1
			"
			class="container-buttons"
		>
			<input
				id="ranking"
				v-model="evaluationQuestions.isRanking"
				type="checkbox"
				class="checkbox"
			/>
			<label for="ranking" class="heading-5">{{ $t('ranking') }}</label>
		</div>
		<div>
			<ja-textarea
				v-model="evaluationQuestions.question"
				class="text--bold-600"
				:max-length="500"
				:label="$t('enterQuestion')"
				:name="$t('enterQuestion')"
			></ja-textarea>
			<span class="body-text-2">{{ $t('max') }} {{ '500' }}</span>
		</div>
		<!-- Multiple option -->
		<div
			v-if="
				evaluationQuestions.cmsLifeStyleQuestionFormat
					.lifestyle_Question_Format_ID === 5
			"
		>
			<div
				v-for="(option,
				index) in evaluationQuestions.cmsLifestyleQuestionAnswerOptions"
				:key="index"
				class="answer-option"
			>
				<label class="heading-5 text--bold-600"
					>{{ $t('answerOption') }} {{ index + 1 }}</label
				>
				<div class="container-buttons">
					<div v-if="!evaluationQuestions.isRanking" class="input-score">
						<label class="heading-5" for="others">{{ $t('others') }}</label>
						<input
							v-model="option.isOthers"
							type="checkbox"
							class="checkbox"
							name="others"
						/>
					</div>
					<ja-input
						v-model="option.score"
						class="input-score"
						size="small"
						:max-length="2"
						is-number-input
						:label="$t('score')"
						:name="$t('score')"
					></ja-input>
				</div>
				<div v-if="!option.isOthers" class="text-label">
					<ja-textarea
						v-model="option.text"
						:max-length="200"
						:label="$t('text')"
						:name="$t('text')"
					></ja-textarea>
					<span class="body-text-2">{{ $t('max') }} {{ '200' }}</span>
				</div>
				<a
					v-if="index > 0"
					class="heading-5 text-button"
					href="#"
					@click="deleteAnswer(index)"
				>
					{{ $t('deleteAnswer') }}</a
				>
			</div>
			<div class="container-buttons questions">
				<a href="#" class="heading-5 text-button" @click="addAnswerOption">{{
					$t('addMoreOption')
				}}</a>
			</div>
		</div>
		<!-- True / false -->
		<div
			v-if="
				evaluationQuestions.cmsLifeStyleQuestionFormat
					.lifestyle_Question_Format_ID === 6
			"
		>
			<div
				v-for="(option,
				index) in evaluationQuestions.cmsLifestyleQuestionAnswerOptions"
				:key="index"
				class="answer-option text--bold-600"
			>
				<label class="heading-5 text--bold-600"
					>{{ $t('answerOption') }} {{ index + 1 }}</label
				>
				<div class="container-buttons">
					<ja-input
						v-model="option.score"
						class="input-score"
						size="small"
						:max-length="2"
						is-number-input
						:label="$t('score')"
						:name="$t('score')"
					></ja-input>
				</div>
				<div class="text-label">
					<ja-textarea
						v-model="option.text"
						:max-length="200"
						:label="$t('text')"
						:name="$t('text')"
						disabled
					></ja-textarea>
				</div>
			</div>
		</div>
		<div class="container-buttons save">
			<ja-button
				name="save"
				class="small outlined"
				:disabled="evaluationQuestions.question.length <= 0"
				@click.native="saveQuestion"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
		</div>
	</div>
</template>
<script>
import { Dropdown, Textarea, Input } from '@/components/ui/form';
import Button from '@/components/ui/Button';
import {
	lifestyleQuestionTypes,
	lifeStageDropdown,
	ID_NEW_CMS
} from '@/helpers/constants';
import AdminFacility from '@/mixins/AdminFacility';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaDropdown: Dropdown,
		jaTextarea: Textarea,
		jaButton: Button,
		jaInput: Input
	},
	mixins: [AdminFacility],
	props: {
		dataEdit: {
			type: Object,
			default: null,
			required: false
		}
	},
	data() {
		return {
			questionTypeIndex: 0,
			lifeStageIndex: 0,
			questionFormatIndex: 0,
			lifestyleQuestionTypes: lifestyleQuestionTypes,
			lifeStageOptions: lifeStageDropdown,
			evaluationQuestions: null
		};
	},
	computed: {
		questionTypeOptions() {
			const filteredOptions = this.dataEdit.questionType
				.filter(format => {
					if (this.isSuperAdmin || this.isUSAAdmin) {
						return (
							format.lifestyle_Question_Type_ID ===
								this.lifestyleQuestionTypes.KNOWLEDGE ||
							format.lifestyle_Question_Type_ID ===
								this.lifestyleQuestionTypes.PREPOST
						);
					} else {
						return (
							format.lifestyle_Question_Type_ID ===
							this.lifestyleQuestionTypes.PREPOST
						);
					}
				})
				.map(format => ({ ...format, name: format.questionType }));
			return filteredOptions;
		},
		questionFormatOptions() {
			const filteredOptions = this.dataEdit.questionFormat
				.filter(
					format =>
						format.lifestyle_Question_Format_ID === 1 ||
						format.lifestyle_Question_Format_ID === 5 ||
						format.lifestyle_Question_Format_ID === 6
				)
				.map(format => ({ ...format, name: format.questionFormat }));
			return filteredOptions;
		}
	},
	watch: {
		questionTypeIndex(newIndex) {
			this.evaluationQuestions.cmsLifestyleQuestionType = this.questionTypeOptions[
				newIndex
			];
			this.evaluationQuestions.lifestyle_Question_Type_ID = this.evaluationQuestions.cmsLifestyleQuestionType.lifestyle_Question_Type_ID;
		},
		lifeStageIndex(newIndex) {
			this.evaluationQuestions.lifeStage_ID = this.lifeStageOptions[
				newIndex
			].lifeStage_ID;
		},
		questionFormatIndex(newIndex) {
			const isAnswerOptionsTrueOrFalse = this.evaluationQuestions.cmsLifestyleQuestionAnswerOptions.every(
				option => option.text === 'True' || option.text === 'False'
			);
			if (
				this.questionFormatOptions[newIndex].lifestyle_Question_Format_ID ===
					6 &&
				!isAnswerOptionsTrueOrFalse
			) {
				this.evaluationQuestions.cmsLifestyleQuestionAnswerOptions = [
					{
						score: 0,
						text: 'True',
						isActive: true,
						isOthers: false,
						optionOrder: 1,
						lifestyle_Question_ID: this.evaluationQuestions
							.lifestyle_Question_ID
					},
					{
						score: 0,
						text: 'False',
						isActive: true,
						isOthers: false,
						optionOrder: 2,
						lifestyle_Question_ID: this.evaluationQuestions
							.lifestyle_Question_ID
					}
				];
			}
			this.evaluationQuestions.cmsLifeStyleQuestionFormat = this.questionFormatOptions[
				newIndex
			];
			this.evaluationQuestions.lifestyle_Question_Format_ID = this.evaluationQuestions.cmsLifeStyleQuestionFormat.lifestyle_Question_Format_ID;
		}
	},
	created() {
		this.evaluationQuestions = this.dataEdit.lifestyleQuestion;
		if (this.evaluationQuestions.lifeStage_ID === null) {
			this.evaluationQuestions.lifeStage_ID = this.lifeStageOptions[0].lifeStage_ID;
		}
		if (this.evaluationQuestions.lifestyle_Question_ID === ID_NEW_CMS) {
			this.setCreateNew();
		} else {
			this.setInitialIndexes();
		}
	},
	methods: {
		setCreateNew() {
			this.evaluationQuestions.cmsLifeStyleQuestionFormat = this.questionFormatOptions[0];
			this.evaluationQuestions.cmsLifestyleQuestionType = this.questionTypeOptions[0];
			this.evaluationQuestions.lifestyle_Question_Format_ID = this.evaluationQuestions.cmsLifeStyleQuestionFormat.lifestyle_Question_Format_ID;
			this.evaluationQuestions.lifestyle_Question_Type_ID = this.evaluationQuestions.cmsLifestyleQuestionType.lifestyle_Question_Type_ID;
			this.evaluationQuestions.question = '';
			this.evaluationQuestions.parentRow_ID = ID_NEW_CMS;
		},
		setInitialIndexes() {
			if (this.evaluationQuestions.lifestyle_Question_ID) {
				this.questionTypeIndex = this.questionTypeOptions.findIndex(
					option =>
						option.lifestyle_Question_Type_ID ===
						this.evaluationQuestions.cmsLifestyleQuestionType
							.lifestyle_Question_Type_ID
				);
				this.lifeStageIndex = this.lifeStageOptions.findIndex(
					option =>
						option.lifeStage_ID === this.evaluationQuestions.lifeStage_ID
				);
				this.questionFormatIndex = this.questionFormatOptions.findIndex(
					option =>
						option.lifestyle_Question_Format_ID ===
						this.evaluationQuestions.cmsLifeStyleQuestionFormat
							.lifestyle_Question_Format_ID
				);
			}
		},
		addAnswerOption() {
			this.evaluationQuestions.cmsLifestyleQuestionAnswerOptions.push({
				isOthers: false,
				score: '',
				text: '',
				optionOrder:
					this.evaluationQuestions.cmsLifestyleQuestionAnswerOptions.length + 1,
				lifestyle_Question_ID: this.evaluationQuestions.lifestyle_Question_ID
			});
		},
		deleteAnswer(index) {
			if (
				index >= 0 &&
				index <
					this.evaluationQuestions.cmsLifestyleQuestionAnswerOptions.length
			) {
				this.evaluationQuestions.cmsLifestyleQuestionAnswerOptions.splice(
					index,
					1
				);
			}
		},
		saveQuestion() {
			if (
				this.evaluationQuestions.lifestyle_Question_Type_ID ===
				this.lifestyleQuestionTypes.PREPOST
			) {
				const order = parseInt(this.evaluationQuestions.optionOrder);
				this.evaluationQuestions.optionOrder = isNaN(order) ? 0 : order;
			}
			this.evaluationQuestions.isActive = true;

			this.evaluationQuestions.cmsLifestyleQuestionAnswerOptions.forEach(
				answer => {
					const score = parseInt(answer.scrore);
					answer.score = isNaN(score) ? 0 : score;
				}
			);
			this.$emit('saveQuestion', this.evaluationQuestions);
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-evaluation-question {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.container-buttons {
	display: flex;
	align-items: center;
	gap: 20px;
	margin-top: 10px;
}
.questions {
	justify-content: flex-start;
}
.save {
	justify-content: flex-end;
}
.input-score {
	display: flex;
	gap: 10px;
	align-items: center;
	::v-deep label .heading-5 {
		margin-bottom: 0px;
	}
}
.heading-5 {
	color: $font-dark;
}
.text-button {
	color: $link-font-color;
}
.text-label {
	margin: 10px 0 10px 0;
}
.answer-option {
	margin-top: 30px;
}
</style>
